import React from 'react';
import { User, Users } from 'lucide-react';

const OPTIONS = [
  { key: 'mine', label: 'My jobs', Icon: User, hint: 'Showing jobs assigned directly to you.' },
  { key: 'team', label: "My team's jobs", Icon: Users, hint: 'Showing your jobs plus jobs assigned to your team.' },
];

// Pill toggle for workers/supervisors: which jobs the list should include.
export const JobScopeToggle = ({ scope, onChange, showHint = true }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="jobs-scope-toggle">
    <div className="inline-flex rounded-full p-0.5" style={{ background: '#1A2433', border: '1px solid #2D3748' }}>
      {OPTIONS.map(({ key, label, Icon }) => {
        const on = scope === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            aria-pressed={on}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors"
            style={{ background: on ? '#1E88E5' : 'transparent', color: on ? '#FFFFFF' : '#94A3B8' }}
            data-testid={`jobs-scope-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </button>
        );
      })}
    </div>
    {showHint && (
      <span className="text-[11px]" style={{ color: '#64748B' }} data-testid="jobs-scope-hint">
        {OPTIONS.find((o) => o.key === scope)?.hint}
      </span>
    )}
  </div>
);
